// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => ("static/js/" + chunkId + "." + {"46":"b32d5b4d","641":"b8604f72"}[chunkId] + ".chunk.js");